import {useEffect} from "react";

export const useFaqFont = () => {
    useEffect(() => {
        // コンポーネントがマウントされたときにクラスを追加
        document.body.classList.add('faq-font');

        // コンポーネントがアンマウントされたときにクラスを削除
        return () => {
            document.body.classList.remove('faq-font');
        };
    }, []);
}